import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import appConfig from '../config/app-config';

@Injectable({
  providedIn: 'root'
})

export class ApiService {

  constructor(private http: HttpClient) {
  }

  public getHeader(headers: any) {
    if (headers) {
      headers = new HttpHeaders({'Content-Type': 'application/json', ...headers});
    }
    return {headers};
  }

  public httpGet(url: any) {
    return this.http.get(appConfig.baseUrl + url)
  }

  public httpGetVettimes(url: any) {
    return this.http.get(appConfig.vettimesUrl + url)
  }

  public httpPost(url: string, body: any, headers?: any) {
    return this.http.post(appConfig.baseUrl + url, body, this.getHeader(headers));
  }
  
  public exportExcel(url: string) {
    window.location.href = url
  }
}
